import { render, staticRenderFns } from "./pageDivFooterSetting.vue?vue&type=template&id=41903e8c&scoped=true&"
import script from "./pageDivFooterSetting.vue?vue&type=script&lang=js&"
export * from "./pageDivFooterSetting.vue?vue&type=script&lang=js&"
import style0 from "./pageDivFooterSetting.vue?vue&type=style&index=0&id=41903e8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41903e8c",
  null
  
)

export default component.exports